/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCategory2 = createReactComponent("outline", "category-2", "IconCategory2", [["path", { "d": "M14 4h6v6h-6z", "key": "svg-0" }], ["path", { "d": "M4 14h6v6h-6z", "key": "svg-1" }], ["path", { "d": "M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M7 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-3" }]]);

export { IconCategory2 as default };
//# sourceMappingURL=IconCategory2.mjs.map
